<template>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :width="isMobile ? '90%' : '800px'"
      :before-close="handleClose"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="feedback-dialog"
    >
      <div slot="title" class="dialog-title">
        <span style="font-size: 24px;">{{ title }}</span>
        <div style="color: #ff0000;padding-top: 5px;">请留下您对社区建设的宝贵想法或建议，若有技术问题，欢迎发帖交流。</div>
      </div>
  
      <div class="editor-container" v-loading="loading">
        <el-form 
          :model="form" 
          ref="form" 
          :rules="rules"
          class="form-container"
        >
          <!-- 邮箱表单项 -->
          <el-form-item 
            label="邮箱" 
            prop="email"
            class="form-item"
          >
            <el-input 
              v-model="form.email" 
              placeholder="请输入您的邮箱（用于接收回复）"
              class="custom-input"
            ></el-input>
          </el-form-item>
  
          <!-- 反馈内容项 -->
          <el-form-item 
            label="意见&反馈" 
            prop="content"
            class="form-item"
          >
            <el-input
              type="textarea"
              placeholder="请详细描述您的意见&反馈"
              v-model="form.content"
              class="custom-textarea"
              maxlength="1000"
              show-word-limit
              :rows="isMobile ? 7 : 8" 
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
  
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" class="btn-cancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit" class="btn-submit">提交反馈</el-button>
      </div>
    </el-dialog>
  </template>
  
  <script>
  import { saveFeedBack } from "@/service/feedback";
  
  export default {
    name: "FeedbackDialog",
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: "意见&反馈"
      },
      email: {
        type: String,
        default: ""
      },
    },
    data() {
      return {
        loading: false,
        form: {
          email: "",
          content: ""
        },
        rules: {
          email: [
            { required: true, message: "请输入邮箱", trigger: "blur" },
            { type: "email", message: "请输入有效的邮箱地址", trigger: "blur" }
          ],
          content: [
            { required: true, message: "请输入反馈内容", trigger: "blur" },
            { min: 5, message: "反馈内容至少5个字", trigger: "blur" }
          ]
        }
      };
    },
    computed: {
      // 判断是否为移动端设备
      isMobile() {
        return window.innerWidth < 768;
      }
    },
    watch: {
      visible(val) {
        if (val) {
          this.form.email = this.email;
        } else {
          this.resetForm();
        }
      }
    },
    methods: {
      handleSubmit() {
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$confirm("确认提交反馈吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "info"
            }).then(() => {
              this.handleSavePost();
            }).catch(() => {
              this.$message({ type: "info", message: "已取消提交" });
            });
          }
        });
      },
      handleSavePost() {
        this.loading = true;
        saveFeedBack({
          email: this.form.email,
          content: this.form.content
        }).then(({ code, message }) => {
          this.loading = false;
          if (code === 0) {
            this.$message.success("提交成功，感谢您的反馈！");
            this.$emit("update:visible", false);
            this.resetForm();
          } else {
            this.$message.error(message || "提交失败，请重试");
          }
        }).catch(() => {
          this.loading = false;
          this.$message.error("网络异常，请稍后重试");
        });
      },
      handleClose() {
        this.$confirm("确认取消？已输入内容将不保存", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$emit("update:visible", false);
          this.resetForm();
        });
      },
      resetForm() {
        this.$refs.form?.resetFields();
        this.loading = false;
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  // 弹窗核心样式（居中+宽度控制）
  ::v-deep .feedback-dialog {
    // 强制居中
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    
    // 基础样式
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  
  // 移动端最大宽度限制（不超过360px）
  @media (max-width: 767px) {
    ::v-deep .feedback-dialog {
      max-width: 360px !important;
    }
  }
  
  // 电脑端宽度固定为800px
  @media (min-width: 768px) {
    ::v-deep .feedback-dialog {
      width: 800px !important;
    }
  }
  
  // 标题样式
  .dialog-title {
    position: relative;
    font-size: 18px;
    font-weight: 600;
    color: #333;
  
    .title-line {
      top: 30px;
      left: 0;
      width: 36px;
      height: 2px;
      background: #409eff;
      border-radius: 2px;
      position: absolute;
    }
  }

  // 表单容器
  .form-container {
    width: 100%;
    margin: 0;
    padding: 0;
  }
  
  // 表单项样式
  ::v-deep .form-item {
    margin-bottom: 16px;
  
    // 移动端标签居上
    .el-form-item__label {
      display: block;
      width: 100% !important;
      padding: 0 0 6px 0;
      text-align: left;
      font-size: 14px;
      color: #666;
    }
  
    // 输入区域
    .el-form-item__content {
      width: 100% !important;
      margin: 0 !important;
      padding: 0;
  
      // 错误提示
      .el-form-item__error {
        position: static !important;
        display: block;
        margin-top: 4px;
        padding: 0;
        font-size: 12px;
        color: #f56c6c;
        text-align: left !important;
        line-height: 1.4;
      }
    }
  }
  
  // 邮箱输入框样式
  ::v-deep .custom-input {
    width: 100%;
    height: 44px;
    border: none !important;
    padding: 0 !important;
  
    .el-input__inner {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      border: 1px solid #e0e0e0;
      padding: 0 12px;
      font-size: 14px;
      transition: all 0.3s;
  
      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
        outline: none;
      }
    }
  }
  
  // 反馈文本域样式
  ::v-deep .custom-textarea {
    width: 100%;
    border: none !important;
    padding: 0 !important;
  
    .el-textarea__inner {
      min-height: 160px;
      border-radius: 6px;
      border: 1px solid #e0e0e0;
      padding: 12px 14px;
      font-size: 14px;
      line-height: 1.6;
      resize: vertical;
  
      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
        outline: none;
      }
    }
  
    .el-input__count {
      color: #999;
      font-size: 11px;
      margin-top: 4px;
      text-align: right;
    }
  }
  
  // 底部按钮
  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  
    .btn-cancel, .btn-submit {
      padding: 8px 16px;
      font-size: 14px;
      border-radius: 6px;
      flex-shrink: 0;
    }
  
    .btn-submit {
      background: #409eff;
      border-color: #409eff;
  
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
  
  // 电脑端表单项水平布局
  @media (min-width: 768px) {
    ::v-deep .form-item {
      display: flex;
      align-items: center;
  
      .el-form-item__label {
        display: inline-block;
        width: 100px !important;
        padding: 0 10px 0 0;
        text-align: right;
      }
    }
  
    ::v-deep .custom-textarea .el-textarea__inner {
      min-height: 200px;
    }
  
    ::v-deep .feedback-dialog .el-dialog__header {
      padding: 24px 20px 16px;
    }
    
    ::v-deep .feedback-dialog .el-dialog__body {
      padding: 20px 20px;
    }
  }
  
  // 移动端内边距调整
  @media (max-width: 767px) {
    ::v-deep .feedback-dialog .el-dialog__header {
      padding: 16px 14px 12px;
    }
    
    ::v-deep .feedback-dialog .el-dialog__body {
      padding: 12px 14px;
    }
    
    ::v-deep .feedback-dialog .el-dialog__footer {
      padding: 12px 14px;
    }
  }
  </style>